/* eslint-disable import/prefer-default-export */
/*
 * @description: determine if a browser is performing slowly
 * This can be used to trigger debouncing or other behaviors
 * which will deliver a faster experience while allowing
 * faster browsers or hardware to deliver the optimal
 * UX experience
 *
 * @todo: currently it only return true or false if IE11
 * need to create a small loop that can be used as a baseline
 *
 * @todo: add output to a context or cache so we don't need
 * to rerun the test multiple times.
 */
export function isBrowserSlow() {
  // https://stackoverflow.com/a/21712356
  const isInternetExplorer = !!window.document.documentMode;
  return isInternetExplorer;
}
